module.exports = __webpack_public_path__ + "img/republic-of-poland.e1b3ac4b.png";